const HTML_UNSAFE_CHARACTERS = /[<>&\u2028\u2029]/g;

const HTML_SAFE_ESCAPES: Record<string, string> = {
  "<": "\\u003c",
  ">": "\\u003e",
  "&": "\\u0026",
  "\u2028": "\\u2028",
  "\u2029": "\\u2029",
};

export function serializeJsonLd(value: object): string {
  return JSON.stringify(value).replace(
    HTML_UNSAFE_CHARACTERS,
    (character) => HTML_SAFE_ESCAPES[character],
  );
}
